import { GameLayer } from "../GameLayer";
import { ewent } from "../../reactive";
export class InteractionGuard {
    constructor() {
        this.interaction = null;
        this.default_layer = null;
    }
    setDefaultLayer(def) {
        this.default_layer = def;
        return this;
    }
    set(interaction, target = null) {
        this.reset();
        if (interaction) {
            if (interaction._guard)
                interaction._guard.reset();
            this.interaction = interaction;
            interaction._guard = this;
            interaction.addTo(target || this.default_layer);
        }
        return interaction;
    }
    reset() {
        if (this.interaction) {
            this.interaction._guard = null;
            this.interaction.cancel();
        }
        this.interaction = null;
        return this;
    }
}
export default class InteractionLayer extends GameLayer {
    constructor() {
        super(...arguments);
        this.top_control = null;
        this._guard = null;
        this.started = ewent();
        this.ended = ewent();
    }
    onAdd(map) {
        super.onAdd(map);
        this.started.trigger(this);
        this.getMap().container.focus();
        return this;
    }
    attachTopControl(tc) {
        if (this.top_control) {
            this.top_control.remove();
            this.top_control = null;
        }
        if (tc) {
            tc.setCancelHandler(() => this.cancel()).addTo(this);
            this.top_control = tc;
        }
        return this;
    }
    cancel() {
        if (this._guard)
            this._guard.reset();
        this.remove();
        this.ended.trigger(this);
    }
    onEnd(handler) {
        this.ended.on(handler);
        return this;
    }
    onStart(handler) {
        this.started.on(handler);
        return this;
    }
}
